import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import settingService from '../services/setting.service';

export const fetchSettingList = createAsyncThunk(
  'setting/fetchSettingList',
  async (_, rejectWithValue ) => {
    try {
      const response = await settingService.getSettingList();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const saveCompanySetting = createAsyncThunk(
  'setting/saveCompanySetting',
  async ({payload}, thunkAPI) => {
    try {
      const response = await settingService.addCompanySetting(payload);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const saveFinancialSetting = createAsyncThunk(
  'setting/saveFinancialSetting',
  async ({ payload }, thunkAPI) => {
    try {
      const response = await settingService.addFinancialSetting(payload);
      return response.data; // Return the updated customer data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const saveTaxComplianceSetting = createAsyncThunk(
  'setting/saveTaxComplianceSetting',
  async ({payload}, thunkAPI) => {
    try {
      const response = await settingService.addTaxComplianceSetting(payload);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const saveNotificationSetting = createAsyncThunk(
  'setting/saveNotificationSetting',
  async ({ payload }, thunkAPI) => {
    try {
      const response = await settingService.addNotificationSetting(payload);
      return response.data; // Return the updated customer data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const saveTermsConditionSetting= createAsyncThunk(
  'setting/saveTermsConditionSetting',
  async ({ payload }, thunkAPI) => {
    try {
      const response = await settingService.addTermsConditionSetting(payload);
      return response.data; // Return the updated customer data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  data: [],
   status: 'idle',
  error: null,
  loading: false,
  hasMore: true,
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    resetSettingData: (state) => {
      state.data = []; // This will clear the list
    },
    resetSettings: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSettingList.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
      })
      .addCase(fetchSettingList.fulfilled, (state, action) => {
         state.status = 'succeeded';
        state.data = action.payload.data || [];
      })
      .addCase(fetchSettingList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(saveCompanySetting.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveCompanySetting.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(saveCompanySetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

    builder
      .addCase(saveFinancialSetting.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveFinancialSetting.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(saveFinancialSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

      builder
      .addCase(saveTaxComplianceSetting.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveTaxComplianceSetting.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(saveTaxComplianceSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

      builder
      .addCase(saveNotificationSetting.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveNotificationSetting.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(saveNotificationSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

      builder
      .addCase(saveTermsConditionSetting.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveTermsConditionSetting.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(saveTermsConditionSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});


export const { resetSettingData, resetSettings } = settingSlice.actions;
export default settingSlice.reducer;


